export const AUTH_MODES = {
    CLERK: "clerk",
    LOCAL_LAB: "local-lab",
};
export const LOCAL_LAB_AUTH_TOKEN = "local-lab";
//# sourceMappingURL=auth.js.map